module.exports = __webpack_public_path__ + "img/google.36505a09.svg";